import React from "react";
import { IconSparkles } from "@tabler/icons-react";
import { twMerge } from "tailwind-merge";

type IWizardHeader = {
  className?: string;
};

const WizardHeader: React.FC<IWizardHeader> = ({ className }) => {
  return (
    <div
      className={twMerge("px-6 pb-20 pt-14 text-center sm:px-10", className)}
    >
      <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/10 px-4 py-1.5 text-xs font-semibold text-primary-500">
        <IconSparkles size={14} stroke={2.5} />
        Powered by AI
      </span>
      <h1 className="mt-5 font-serif text-3xl lg:text-6xl text-white sm:text-4xl">
        AI Compliance <span className="text-primary-500">Assistant</span>
      </h1>
      <p className="mx-auto mt-3 max-w-xl text-sm lg:text-lg text-white">
        Register your company and generate compliance documents across Africa —
        guided step by step with intelligent automation.
      </p>
    </div>
  );
};

export default WizardHeader;
